import { Component } from 'vue-property-decorator';
import { Page } from '../../helpers/components';
import { BasePage } from '../base-page';
import { apartmentsLocationsData } from './apartments-locations.data';
import { WmsLayout } from '../../components/layout/layout';

@Page(WmsLayout, apartmentsLocationsData) @Component
export class ApartmentsLocationsPage extends BasePage {
}

export default ApartmentsLocationsPage;
